export const UPDATE_FLYER_ZOOM = 'UPDATE_FLYER_ZOOM'
export const SET_CUSTOM_FLYER_BG = 'SET_CUSTOM_FLYER_BG'
export const CLEAR_CUSTOM_FLYER_BG = 'CLEAR_CUSTOM_FLYER_BG'

export function updateFlyerZoom (flyerZoom) {
  return {
    type: UPDATE_FLYER_ZOOM,
    flyerZoom
  }
}

export function setCustomFlyerBg (bgDataURL) {
  return {
    type: SET_CUSTOM_FLYER_BG,
    bgDataURL
  }
}

export function clearCustomFlyerBg() {
  return {
    type: CLEAR_CUSTOM_FLYER_BG
  }
}
